<template>
  <div>
    <div class="pc">
      <div class="pc-box">
        <div class="pc-box-left">
          <div class="pc-title1">图上征收 \ 移动查勘 \ 档案管理</div>
          <div class="pc-title2">更懂征收之道的云管家</div>
          <div class="pc-title2">云征收</div>
          <div class="pc-title3" style="margin-top: 60px;padding-left: 52px;text-indent: 0;">
            华云声隶属于深圳房讯通信息技术有限公司，是一家专注于征收棚改、城市更新和土地资源管理行业的科技服务公司，通过信息化系统及第三方专业服务为政府提供咨询管理服务，
            推行高效、阳光、有序的征收和对图上征收土地现状实施精准管理。
          </div>
        </div>
        <div class="pc-box-right">
          <img src="../assets/img/index_01.png" />
        </div>
      </div>
    </div>
    <div class="middle-box">
      <div class="land-acquisition">
        <h2 class="land-acquisition-title">房屋征收</h2>
        <baseSwiper class="swiper" :delay="800" :height="500" :speedLimit="true" :gap="gapWidth">
          <baseSwiperItem v-for="(item, index) of list" :key="index">
            <div style="width:100%">
              <div class="content">
                <div class="content-img-box">
                  <img :src="item.src" alt />
                </div>
                <div class="content-test">
                  <div class="content-title-one">{{item.productName}}</div>
                  <div class="content-title-two">{{item.title}}</div>
                </div>
                <div class="content-btn" @click="toMore(item.path)">了解更多</div>
              </div>
            </div>
          </baseSwiperItem>
        </baseSwiper>
      </div>
      <div class="information-application">
        <h2 class="land-acquisition-title">地理信息应用</h2>
        <div class="information-application-box">
          <div class="information-application-left">
            <div class="information-application-img">
              <img src="../assets/img/index_06.png" />
            </div>
            <div class="information-application-title" @click="toGis()">
              <span class="application-title-one1">GIS资产管理平台</span>
              <span class="application-title-two">GIS资产地图分布</span>
              <span class="application-title-two">资产租金自动评估</span>
              <span class="application-title-two">资产现状及收益分析</span>
            </div>
          </div>
          <div class="information-application-right">
            <div class="information-application-img">
              <img src="../assets/img/index_07.png" />
            </div>
            <div class="information-application-title" @click="thGisOther()">
              <span class="application-title-one1">GIS一张图空间规划平台</span>
              <span class="application-title-two">专题图层可视化</span>
              <span class="application-title-two">三维空间展示</span>
              <span class="application-title-two">大数据分析</span>
            </div>
          </div>
        </div>
      </div>
      <div class="professional-service">
        <h2 class="land-acquisition-title">专业服务</h2>
        <div class="professional-service-box">
          <div class="professional-service-one" @click="toOther('/service')">
            <img src="../assets/img/hangpai_011.png" />
            <div class="professional-service-text">航拍服务</div>
          </div>
          <div class="professional-service-one" @click="toOther('/process')">
            <img src="../assets/img/quanliucheng_011.png" />
            <div class="professional-service-text">全流程征收服务</div>
          </div>
          <div class="professional-service-one" @click="toOther('/management')">
            <img src="../assets/img/dangan.png" />
            <div class="professional-service-text">档案整理服务</div>
          </div>
          <div class="professional-service-one" @click="toOther('/panoramic')">
            <img src="../assets/img/quanjing_00.png" />
            <div class="professional-service-text">全景航拍服务</div>
          </div>
        </div>
      </div>
      <div class="partner-content">
        <h2 class="land-acquisition-title">合作伙伴</h2>
        <div class="partner-content-box">
          <div class="partner-content-one" v-for="(item,index) in partnerList" :key="index">
            <div class="partner-content-left">
              <img :src="item.src" />
            </div>
            <div class="partner-content-text">{{item.name}}</div>
          </div>
          <div class="btn-box">
            <div class="btn" @click="toAdd">申请试用</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import baseSwiper from '@/components/base-swiper.vue';
import baseSwiperItem from '@/components/base-swiper-item.vue';
export default {
  name: 'HelloWorld',
  components: {
    baseSwiper,
    baseSwiperItem
  },
  computed: {
    gapWidth() {
      if (window.innerWidth < 1500) {
        return 100;
      }
    }
  },
  data() {
    return {
      flag: false,
      caseList: [],
      list: [
        {
          src: require('../assets/img/index_021.png'),
          productName: '评估端',
          title:
            '为评估机构量身打造，结合Ipad等硬件，提高评估机构的外业查勘作业效率，实现业务信息化',
          path: '/product'
        },
        {
          src: require('../assets/img/quancheng_01.png'),
          productName: '全程端',
          title:
            ' 基于集体土地和国有土地上房屋征收打造的全流程一体化征收业务管理平台',
          path: '/whole'
        },
        {
          src: require('../assets/img/tuzheng_01.png'),
          productName: '智慧征收系统',
          title:
            ' 采用一图规划、支持多方作业，结合土地收储、房屋征收等业务形成的一站式信息化管理平台',
          path: '/collection'
        },
        {
          src: require('../assets/img/beizhengshouhu_00.png'),
          productName: '被征收户端',
          title:
            '为征收项目里的征收户提供所属项目动迁信息、个人补偿信息、安置信息的查询',
          path: '/client'
        }
      ],
      partnerList: [
        {
          name: '浙江博大',
          src: require('../assets/img/zjbd.png')
        },
        {
          name: '西安通易',
          src: require('../assets/img/xaty.png')
        },
        {
          name: '四平恒通',
          src: require('../assets/img/spht.png')
        },
        {
          name: '衢州华辰',
          src: require('../assets/img/zzhc.png')
        },
        {
          name: '山西智渊',
          src: require('../assets/img/sxzy.png')
        },
        {
          name: '江西利仁',
          src: require('../assets/img/jxle.png')
        },
        {
          name: '武汉华汉',
          src: require('../assets/img/whhh.png')
        },
        {
          name: '天津中盛',
          src: require('../assets/img/tjzs.png')
        },
        {
          name: '北京潞通',
          src: require('../assets/img/bjlt.jpg')
        },
        {
          name: '安徽中信',
          src: require('../assets/img/ahzx.png')
        },
        {
          name: '新疆中鼎',
          src: require('../assets/img/xjzd.png')
        },
        {
          name: '宁波中升',
          src: require('../assets/img/nbzs.jpg')
        },
        {
          name: '山东金庆',
          src: require('../assets/img/sdjq.png')
        },
        {
          name: '新余广泰',
          src: require('../assets/img/xygt.png')
        },
        {
          name: '河北正达',
          src: require('../assets/img/hbzd.jpg')
        },
        {
          name: '深圳世鹏',
          src: require('../assets/img/szsp.png')
        },
        {
          name: '山东大地',
          src: require('../assets/img/sddd.png')
        },
        {
          name: '贵州九天',
          src: require('../assets/img/gzjt.png')
        }
      ]
    };
  },
  methods: {
    getList() {},
    toMore(path) {
      this.$router.push(path);
    },
    toGis() {
      this.$router.push('/gis');
    },
    thGisOther() {
      this.$router.push('/gisOther');
    },
    toAdd() {
      this.$router.push('/application');
    },
    toOther(item) {
      this.$router.push(item);
    }
  },
  created() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.pc {
  background: url('../assets/img/302.png') no-repeat center;
  background-size: 100% 650px;
  width: 100%;
}
.pc-box {
  /* background: red; */
  height: 640px;
  margin: 0 auto;
  width: 1500px;
  display: flex;
}
.pc-box-left {
  width: 50%;
  text-indent: 48px;
  padding-top: 50px;
}
.pc-title1 {
  font-family: '微软雅黑';
  font-weight: 406;
  font-size: 24px;
  color: #ffffff;
}
.pc-title2 {
  font-family: '微软雅黑 Bold', '微软雅黑 Regular', '微软雅黑';
  font-weight: 700;
  font-style: normal;
  font-size: 60px;
  color: #ffffff;
}
.pc-title3 {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 20px;
  color: #ffffff;
  line-height: 40px;
}
.pc-box-right {
  width: 50%;
  vertical-align: middle;
  display: table-cell;
  text-align: center;
  padding-top: 52px;
}
.pc-box-right img {
  width: 100%;
}
.middle-box {
  margin: auto;
  width: 1500px;
}
.land-acquisition {
  width: 100%;
}
.land-acquisition-title {
  text-align: center;
  /* line-height: 50px; */
}
.information-application {
  width: 100%;
}
.information-application-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  box-sizing: border-box;
  /* height: 270px; */
}
.information-application-left {
  width: 50%;
  border: 1px solid rgba(204, 204, 204, 1);
  display: flex;
}
.information-application-left:hover {
  border-color: rgb(0, 189, 183);
}
.information-application-right:hover {
  border-color: rgb(0, 189, 183);
}
.information-application-right {
  width: 50%;
  margin-left: 24px;
  border: 1px solid rgba(204, 204, 204, 1);
  display: flex;
  cursor: pointer;
}
.information-application-img img {
  width: 294px;
  margin-left: 60px;
  margin-top: 8px;
}
.information-application-title {
  /* padding-left: 30px; */
  width: 50%;
  margin-left: 100px;
}
.application-title-one1 {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  line-height: 80px;
  font-size: 20px;
  color: #333333;
  display: block;
  cursor: pointer;
}
.application-title-two {
  cursor: pointer;
  display: block;
  font-size: 16px;
  display: block;
  color: #333333;
  line-height: 35px;
}
.professional-service {
  width: 100%;
}
.professional-service-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  box-sizing: border-box;
  /* height: 350px; */
}
.professional-service-one {
  width: 25%;
  text-align: center;
  border: 1px solid rgba(204, 204, 204, 1);
  cursor: pointer;
  padding: 20px 20px;
}
.professional-service-one:nth-child(2),
.professional-service-one:nth-child(3),
.professional-service-one:nth-child(4) {
  margin-left: 15px;
}
.professional-service-one:hover {
  border-color: rgb(0, 189, 183);
}
.professional-service-one img {
  /* width: 310px; */
  width: 100%;
}
.professional-service-text {
  font-size: 20px;
  color: #333333;
  line-height: 45px;
  padding-bottom: 20px;
}
.partner-content {
  width: 100%;
  height: 523px;
}
.partner-content-box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
}
.partner-content-one {
  width: 15.96%;
  height: 100px;
  border: 1px solid rgba(204, 204, 204, 1);
  line-height: 100px;
  display: flex;
  /* padding-bottom: 15px; */
}
.partner-content-left,
.partner-content-text {
  width: 50%;
}
.partner-content-one img {
  width: 60px;
  margin-top: 24px;
  margin-left: 39px;
}
.partner-content-text {
  margin-left: 10px;
  font-size: 20px;
  color: #333333;
}
.partner-content-one:nth-child(2),
.partner-content-one:nth-child(3),
.partner-content-one:nth-child(4),
.partner-content-one:nth-child(5),
.partner-content-one:nth-child(6) {
  margin-left: 10px;
}
.partner-content-one:nth-child(8),
.partner-content-one:nth-child(9),
.partner-content-one:nth-child(10),
.partner-content-one:nth-child(11),
.partner-content-one:nth-child(12) {
  margin-left: 10px;
  margin-top: 10px;
}
.partner-content-one:nth-child(7) {
  margin-top: 10px;
}
.partner-content-one:nth-child(14),
.partner-content-one:nth-child(15),
.partner-content-one:nth-child(16),
.partner-content-one:nth-child(17),
.partner-content-one:nth-child(18) {
  margin-left: 10px;
  margin-top: 10px;
}
.partner-content-one:nth-child(13) {
  margin-top: 10px;
}
.partner-content-one:nth-child(3) img {
  width: 60px;
  height: 60px;
}
.btn-box {
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.btn:hover {
  background: rgba(0, 189, 183, 1);
  color: #ffffff;
}
.btn {
  cursor: pointer;
  width: 110px;
  height: 40px;
  border-radius: 10px;
  border: 1px solid rgba(0, 189, 183, 1);
  line-height: 40px;
  color: rgba(0, 189, 183, 1);
  margin: auto;
}
.content {
  width: 398px;
  height: 500px;
  background: inherit;
  background-color: rgba(255, 255, 255, 1);
  box-sizing: border-box;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(215, 215, 215, 1);
  border-radius: 20px;
  -moz-box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
  -webkit-box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
  box-shadow: 3px 3px 5px rgba(204, 204, 204, 0.349019607843137);
}
.content-img-box {
  text-align: center;
  padding: 10px 20px;
}
.content-img-box img {
  width: 100%;
}
.content-test {
  height: 100px;
}
.content-title-one {
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  text-align: center;
  font-size: 20px;
  color: #000000;
  margin-top: 10px;
}
.content-title-two {
  margin-top: 20px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-style: normal;
  font-size: 17px;
  color: #000000;
  line-height: 28px;
  padding: 0 10px;
  text-indent: 10px;
}
.content-btn {
  cursor: pointer;
  width: 110px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  background-color: rgba(255, 255, 255, 1);
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 189, 183, 1);
  border-radius: 10px;
  font-family: '微软雅黑';
  font-weight: 400;
  font-size: 18px;
  color: #00bdb7;
  margin: auto;
  margin-top: 20px;
}
.content-btn:hover {
  background: rgba(0, 189, 183, 1);
  color: #ffffff;
}
</style>
<style media="screen">
/*分辨率低于1280，采用下面的样式*/
@media screen and (max-device-width: 1500px) {
  .pc-box,
  .middle-box {
    width: 1200px !important;
  }
  .pc-box {
    height: 540px !important;
  }
  .pc-title2 {
    font-size: 48px !important;
    margin-top: 20px;
  }
  .pc-title3 {
    font-size: 17px !important;
  }
  .pc-box-right img {
    width: 100% !important;
    /* height: 560px !important; */
  }
  .professional-service-one {
    width: 24% !important;
  }
  /* .professional-service-one img {
    width: 300px !important;
  } */
  .application-title-one1 {
    font-size: 19px !important;
  }
  .content {
    width: 320px !important;
  }
  /* .content-img-box img {
    width: 320px !important;
  } */
  .partner-content-one img {
    margin-left: 20px !important;
  }
  .partner-content-text {
    margin-left: 0px !important;
  }
  .footer-Products {
    margin-left: 20px !important;
    width: 185px !important;
  }
  .footer-Services {
    margin-left: 60px !important;
    width: 120px !important;
  }
  .yzh-public {
    width: 120px !important;
  }
  .information-application-title {
    /* padding-left: 30px; */
    margin-left: 0px !important;
  }
  .content-test {
    height: 140px !important;
  }
  .partner-content-one {
    width: 15.8% !important;
    /* padding-bottom: 15px; */
  }
}
</style>



// WEBPACK FOOTER //
// src/page/house-expropriation.vue